// import React, { useCallback, useEffect, useState, useRef } from "react";
// import {
//   Form,
//   Row,
//   Col,
//   InputGroup,
//   Card,
//   Button,
//   Table,
// } from "react-bootstrap";
// import {
//   IconCopyMinus,
//   IconGridDots,
//   IconInvoice,
//   IconSearch,
//   IconCoin,
//   IconPercentage,
//   IconCurrencyDollar,
//   IconArrowNarrowRight,
//   IconPlus,
//   IconTrash,
//   IconLock,
//   IconLockOpen2,
// } from "@tabler/icons-react";
// import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
// import { useSelector } from "react-redux";
// import { useFormContext, useFieldArray } from "react-hook-form";
// import {
//   API_ENDPOINTS,
//   handleKeyDown,
//   trimText,
// } from "../../constant/_constant";
// import SkuSearchPopUp from "./SkuSearchPopUp";

// import useDebounce from "../../hooks/useDebounce";
// import usePostRequest from "../../hooks/usePostRequest";
// import { toast } from "react-toastify";

// function KitProducts() {
//   const {
//     getValues,
//     register,
//     watch,
//     control,
//     formState: { errors },
//     setValue,
//   } = useFormContext();
//   const contractName = useSelector((state) => state.contract.contractName);

//   const textareaRef = useRef(null);

//   const [dataSuggetion, setDataSuggetion] = useState([]);
//   const [showSkuId, setShowSkuId] = useState(false);
//   const [height, setHeight] = useState();
//   const [shippingHide, setShippingHide] = useState(false);
//   const [totalCostBeforeMargin, setTotalCostBeforeMargin] = useState("0.00");
//   const [totalCostAfterMargin, setTotalCostAfterMargin] = useState("0.00");
//   const [showModal, setShowModal] = useState(false);

//   const [searchProps, setSearchProps] = useState({
//     searchSku: "",
//     searchDescription: "",
//     searchVendor: "",
//     indexIs: "",
//     ContractName: "",
//   });

//   const handleOpenModal = (index, type) => {
//     if (index === null && type === "skuAll") {
//       const currentCards = getValues("cards");
//       const blankIndex = currentCards.findIndex(
//         (card) => !card.skuIdUnique && !card.cost && !card.skuDescription
//       );

//       if (blankIndex !== -1) {
//         setSearchProps({
//           searchSku: "",
//           searchDescription: "",
//           searchVendor: "",
//           indexIs: blankIndex,
//         });
//       } else {
//         setSearchProps({
//           searchSku: "",
//           searchDescription: "",
//           searchVendor: "",
//           indexIs: undefined,
//         });
//       }
//     } else if (index === null && type === "contract") {
//       const currentCards = getValues("cards");
//       const blankIndex = currentCards.findIndex(
//         (card) => !card.skuIdUnique && !card.cost && !card.skuDescription
//       );

//       // setSearchProps({
//       //   searchSku: "",
//       //   searchDescription: "",
//       //   searchVendor: "",
//       //   ContractName: contractName,
//       // });

//       if (blankIndex !== -1) {
//         setSearchProps({
//           searchSku: "",
//           searchDescription: "",
//           searchVendor: "",
//           ContractName: contractName,
//           indexIs: blankIndex,
//         });
//       } else {
//         setSearchProps({
//           searchSku: "",
//           searchDescription: "",
//           searchVendor: "",
//           ContractName: contractName,
//           indexIs: undefined,
//         });
//       }
//     } else {
//       const { vendor, sku, description } = cardSearch[index];
//       setSearchProps({
//         searchSku: sku,
//         searchDescription: description,
//         searchVendor: vendor,
//         indexIs: index,
//       });
//     }
//     setShowModal(true);
//   };

//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//   const {
//     fields: cardFields,
//     append: appendCard,
//     remove: removeCard,
//   } = useFieldArray({
//     control,
//     name: "cards",
//   });

//   const {
//     fields: otherCostFields,
//     append: appendOtherCost,
//     remove: removeOtherCost,
//   } = useFieldArray({
//     control,
//     name: "otherCost",
//   });

//   const handleAddOtherCost = () => {
//     appendOtherCost({
//       Name: "",
//       Amount: "",
//     });
//   };

//   const handleAddCard = () => {
//     appendCard({
//       vendorPartner: "",
//       skuIdUnique: "",
//       skuId: "",
//       skuDescription: "",
//       qty: 1,
//       um: "EA",
//       cost: "",
//       margin: 0,
//       customerCost: "",
//       totalSkuCost: "",
//     });
//     calculateCosts();
//   };

//   const handleAddSku = (product) => {
//     appendCard({
//       vendorPartner: product?.Vendor?.display_name,
//       skuId: product?.sku_display_name,
//       skuIdUnique: product?.sku_id,
//       skuDescription: product?.description,
//       qty: 1,
//       um: "EA",
//       cost: product?.aspetto_price,
//       margin: 0,
//       customerCost: product?.customer_price,
//       totalSkuCost: product?.aspetto_price,
//     });
//     calculateCosts();
//   };

//   const handleLockUnLock = (e, index, type) => {
//     e.stopPropagation();
//   };

//   useEffect(() => {
//     const existingCards = getValues("cards");
//     if (!existingCards || existingCards.length === 0) {
//       appendCard({
//         vendorPartner: "",
//         skuIdUnique: "",
//         skuId: "",
//         skuDescription: "",
//         qty: 1,
//         um: "EA",
//         cost: "",
//         margin: 0,
//         customerCost: "",
//         totalSkuCost: "",
//       });
//     }
//   }, [appendCard, getValues]);

//   const handleRemoveCard = (index) => {
//     const currentCards = getValues("cards");
//     if (cardFields.length > 1) {
//       removeCard(index);
//       setTimeout(() => {
//         const updatedCards = getValues("cards");
//         calculateCosts(updatedCards);
//       }, 0);
//     }
//   };

//   const handleRemoveOthercost = (index) => {
//     const currentOthercost = getValues("otherCost");
//     if (otherCostFields.length > 0) {
//       removeOtherCost(index);
//       setTimeout(() => {
//         const updatedOthercost = getValues("otherCost");
//         calculateCosts(updatedOthercost);
//       }, 0);
//     }
//   };

//   const handleDragEnd = (result) => {
//     const { destination, source } = result;
//     if (!destination || destination.index === source.index) return;
//     const currentValues = getValues("cards");
//     const reorderedCards = [...currentValues];
//     const [removed] = reorderedCards.splice(source.index, 1);
//     reorderedCards.splice(destination.index, 0, removed);
//     setValue("cards", reorderedCards);
//   };

//   const calculateCosts = (name) => {
//     let currentfield = "";
//     if (typeof name === "string") {
//       const pathParts = name.match(/cards\[(\d+)\]\.(\w+)/);
//       currentfield = pathParts ? pathParts[2] : null;
//     }

//     let totalBeforeMargin = 0;
//     let totalAfterMargin = 0;

//     const cards = getValues("cards") || [];
//     const otherCost = getValues("otherCost") || [];

//     const shippingCost = parseFloat(getValues("shippingCost")) || 0;
//     const tax = parseFloat(getValues("tax")) || 0;

//     cards?.forEach((card, index) => {
//       if (currentfield != "") {
//         const customerCostLock = card.customerCostLock;
//         const costLock = card.CostLock;
//         const marginLock = card.marginLock;
//         const qty = parseFloat(card.qty) || 0;
//         let cost = parseFloat(card.cost) || 0;
//         let margin = parseFloat(card.margin) || 0;
//         let customerCost = parseFloat(card.customerCost) || 0;

//         let totalSkuCost = 0;
//         if (
//           customerCostLock == false &&
//           costLock == false &&
//           marginLock == false
//         ) {
//           if (currentfield == "customerCost") {
//             // margin = parseFloat((customerCost / cost - 1) * 100);
//             margin = parseFloat(((customerCost - cost) / customerCost) * 100);
//             totalSkuCost = parseFloat(customerCost) * qty;
//             setValue(`cards[${cards.indexOf(card)}].margin`, margin.toFixed(2));
//             setValue(
//               `cards[${cards.indexOf(card)}].totalSkuCost`,
//               totalSkuCost.toFixed(2)
//             );
//           } else {
//             // const customerCost = cost * (1 + margin / 100);
//             const customerCost = cost / (1 - margin / 100);
//             totalSkuCost = parseFloat(customerCost) * qty;
//             setValue(
//               `cards[${cards.indexOf(card)}].customerCost`,
//               customerCost.toFixed(2)
//             );
//             setValue(
//               `cards[${cards.indexOf(card)}].totalSkuCost`,
//               totalSkuCost.toFixed(2)
//             );
//           }
//         } else if (customerCostLock == true) {
//           if (currentfield == "cost") {
//             // margin = parseFloat((customerCost / cost - 1) * 100);
//             margin = parseFloat(((customerCost - cost) / customerCost) * 100);
//             totalSkuCost = parseFloat(customerCost) * qty;
//             setValue(`cards[${cards.indexOf(card)}].margin`, margin.toFixed(2));
//             setValue(
//               `cards[${cards.indexOf(card)}].totalSkuCost`,
//               totalSkuCost.toFixed(2)
//             );
//           } else {
//             // margin
//             // cost = customerCost / (1 + margin / 100);
//             const customerCost = cost / (1 - margin / 100);
//             totalSkuCost = parseFloat(customerCost) * qty;
//             setValue(`cards[${cards.indexOf(card)}].cost`, cost.toFixed(2));
//             setValue(
//               `cards[${cards.indexOf(card)}].totalSkuCost`,
//               totalSkuCost.toFixed(2)
//             );
//           }
//         } else if (marginLock == true) {
//           if (currentfield == "cost") {
//             // const customerCost = cost * (1 + margin / 100);
//             const customerCost = cost / (1 - margin / 100);
//             totalSkuCost = parseFloat(customerCost) * qty;
//             setValue(
//               `cards[${cards.indexOf(card)}].customerCost`,
//               customerCost.toFixed(2)
//             );
//             setValue(
//               `cards[${cards.indexOf(card)}].totalSkuCost`,
//               totalSkuCost.toFixed(2)
//             );
//           } else {
//             // customer cost
//             // cost = customerCost / (1 + margin / 100);
//             const customerCost = cost / (1 - margin / 100);
//             totalSkuCost = parseFloat(customerCost) * qty;
//             setValue(`cards[${cards.indexOf(card)}].cost`, cost.toFixed(2));
//             setValue(
//               `cards[${cards.indexOf(card)}].totalSkuCost`,
//               totalSkuCost.toFixed(2)
//             );
//           }
//         } else if (costLock == true) {
//           if (currentfield == "margin") {
//             // const customerCost = cost * (1 + margin / 100);
//             const customerCost = cost / (1 - margin / 100);
//             totalSkuCost = parseFloat(customerCost) * qty;
//             setValue(
//               `cards[${cards.indexOf(card)}].customerCost`,
//               customerCost.toFixed(2)
//             );
//             setValue(
//               `cards[${cards.indexOf(card)}].totalSkuCost`,
//               totalSkuCost.toFixed(2)
//             );
//           } else {
//             // customer cost change , need to calculate margin
//             // margin = parseFloat((customerCost / cost - 1) * 100);
//             margin = parseFloat(((customerCost - cost) / customerCost) * 100);
//             totalSkuCost = parseFloat(customerCost) * qty;
//             setValue(`cards[${cards.indexOf(card)}].margin`, margin.toFixed(2));
//             setValue(
//               `cards[${cards.indexOf(card)}].totalSkuCost`,
//               totalSkuCost.toFixed(2)
//             );
//           }
//         }
//         totalBeforeMargin += cost * qty;
//         totalAfterMargin += parseFloat(totalSkuCost);
//       } else {
//         totalBeforeMargin += parseFloat(card.cost * card.qty);
//         totalAfterMargin += parseFloat(card.customerCost * card.qty);
//       }
//     });

//     // Calculate costs for each other cost
//     otherCost?.forEach((costItem) => {
//       const amount = parseFloat(costItem.Amount) || 0;
//       if (amount > 0) {
//         totalBeforeMargin += parseFloat(amount);
//         totalAfterMargin += parseFloat(amount);
//       }
//     });

//     if (shippingCost > 0) {
//       totalBeforeMargin += parseFloat(shippingCost);
//       totalAfterMargin += parseFloat(shippingCost);
//     }

//     // Add tax if enabled
//     if (tax > 0) {
//       // console.log('tax', tax);
//       totalBeforeMargin += parseFloat(tax);
//       totalAfterMargin += parseFloat(tax);
//     }

//     // Set the final values
//     setTotalCostBeforeMargin(parseFloat(totalBeforeMargin).toFixed(2));
//     setTotalCostAfterMargin(parseFloat(totalAfterMargin).toFixed(2));

//     // Update form state
//     setValue("totalCostBeforeMargin", parseFloat(totalBeforeMargin).toFixed(2));
//     setValue("totalCostAfterMargin", parseFloat(totalAfterMargin).toFixed(2));
//   };

//   const isCalculating = useRef(false);

//   const shipping_terms = watch("shipping_terms");

//   useEffect(() => {
//     if (shipping_terms === "FOB Destination") {
//       setShippingHide(true);
//     }
//   }, [watch("shipping_terms")]);

//   useEffect(() => {
//     const subscription = watch((value, { name }) => {
//       //console.log('set name',name);
//       const match = name?.match(
//         /cards\[(\d+)\]\.(qty|cost|margin|customerCost)/
//       );
//       const otherCostMatch = name?.match(/otherCost\[(\d+)\]\.Amount/);
//       if (match || otherCostMatch) {
//         if (!isCalculating.current) {
//           isCalculating.current = true;
//           calculateCosts(name);
//           isCalculating.current = false;
//         }
//       }
//     });
//     return () => subscription.unsubscribe();
//   }, [watch]);

//   useEffect(() => {
//     if (!isCalculating.current) {
//       isCalculating.current = true;
//       calculateCosts();
//       isCalculating.current = false;
//     }
//   }, [watch("shippingCost"), watch("tax"), watch("cards"), watch("otherCost")]);

//   const [activeCardIndex, setActiveCardIndex] = useState(null);
//   const [cardSearch, setCardSearch] = useState(
//     cardFields.map(() => ({
//       vendor: "",
//       description: "",
//       sku: "",
//       showSuggestions: true,
//     }))
//   );

//   const handleInputFocus = (index) => {
//     setActiveCardIndex(index);
//     const updatedCardSearch = cardSearch.map((card, idx) => {
//       if (idx !== index) {
//         return { ...card, showSuggestions: false };
//       }
//       return card;
//     });
//     setCardSearch(updatedCardSearch);
//   };

//   const handleSearchChange = (index, field, value) => {
//     const updatedCardSearch = [...cardSearch];
//     if (field === "sku") {
//       updatedCardSearch[index] = {
//         ...updatedCardSearch[index],
//         sku: value,
//         vendor: "",
//         description: "",
//         showSuggestions: true,
//       };
//     } else if (field === "vendor") {
//       updatedCardSearch[index] = {
//         ...updatedCardSearch[index],
//         vendor: value,
//         sku: "",
//         description: "",
//         showSuggestions: true,
//       };
//     } else if (field === "description") {
//       updatedCardSearch[index] = {
//         ...updatedCardSearch[index],
//         description: value,
//         sku: "",
//         vendor: "",
//         showSuggestions: true,
//       };
//     }
//     setCardSearch(updatedCardSearch);
//   };

//   const { postData: fetchProductSearch, data } = usePostRequest(
//     API_ENDPOINTS.PRODUCT_SUGGETION
//   );

//   const onSuccessData = (data) => {
//     // console.log("data sugesstion",data)
//     setDataSuggetion(data);
//   };

//   useEffect(() => {
//     if (
//       activeCardIndex === null ||
//       !cardSearch[activeCardIndex]?.showSuggestions
//     ) {
//       return;
//     }

//     const { vendor, sku, description } = cardSearch[activeCardIndex];

//     if (!vendor && !sku && !description) {
//       return;
//     }

//     const debounceTimer = setTimeout(() => {
//       fetchProductSearch(
//         {
//           page,
//           limit,
//           type: "inventory",
//           module_type: "RFQ",
//           vendor: vendor?.length > 0 ? vendor : undefined,
//           sku: sku?.length > 0 ? sku : undefined,
//           description: description?.length > 0 ? description : undefined,
//         },
//         onSuccessData
//       );
//     }, 500);
//     return () => clearTimeout(debounceTimer);
//   }, [cardSearch, page, limit, activeCardIndex]);

//   const textAreaRefs = useRef([]);

//   const adjustTextAreaHeight = (index) => {
//     const textArea = textAreaRefs.current[index];
//     if (textArea) {
//       textArea.style.height = "auto";
//       textArea.style.height = `${textArea.scrollHeight}px`;
//     }
//   };

//   const handleProductSelect = (product, index) => {
//     setValue(`cards[${index}].vendorPartner`, product?.Vendor?.display_name, {
//       shouldValidate: true,
//     });
//     setValue(`cards[${index}].skuIdUnique`, product?.sku_id, {
//       shouldValidate: true,
//     });
//     setValue(`cards[${index}].skuId`, product?.sku_display_name, {
//       shouldValidate: true,
//     });
//     setValue(`cards[${index}].skuDescription`, product?.description, {
//       shouldValidate: true,
//     }); // Description update
//     setValue(`cards[${index}].um`, product?.uoi ?? "EA", {
//       shouldValidate: true,
//     });
//     setValue(`cards[${index}].cost`, product?.aspetto_price, {
//       shouldValidate: true,
//     });
//     setValue(`cards[${index}].customerCost`, product?.aspetto_price, {
//       shouldValidate: true,
//     });
//     setValue(`cards[${index}].margin`, product?.margin_percent, {
//       shouldValidate: true,
//     });

//     const textArea = textAreaRefs.current[index];
//     if (textArea) {
//       textArea.value = product?.description;
//       adjustTextAreaHeight(index);
//     }

//     const updatedCardSearch = [...cardSearch];
//     updatedCardSearch[index] = {
//       ...updatedCardSearch[index],
//       showSuggestions: false,
//     };
//     setCardSearch(updatedCardSearch);
//   };

//   useEffect(() => {
//     cardFields.forEach((_, index) => {
//       adjustTextAreaHeight(index);
//     });
//   }, [cardFields]);

//   const cards = watch("cards");

//   const handleLockChange = (field, index) => {
//     const currentState = watch(`cards[${index}]`);
//     if (currentState[field]) {
//       setValue(`cards[${index}].${field}`, false);
//     } else {
//       // Otherwise, lock it and unlock all others
//       setValue(`cards[${index}].CostLock`, field === "CostLock");
//       setValue(`cards[${index}].marginLock`, field === "marginLock");
//       setValue(
//         `cards[${index}].customerCostLock`,
//         field === "customerCostLock"
//       );
//     }
//   };

//   const updateTextAreaWithDescription = (index, description) => {
//     const textArea = textAreaRefs.current[index];
//     if (textArea) {
//       textArea.value = description;
//       adjustTextAreaHeight(index);
//     }
//   };

//   return (
//     <>
//       <SkuSearchPopUp
//         calculateCosts={calculateCosts}
//         show={showModal}
//         searchProps={searchProps}
//         updateTextArea={updateTextAreaWithDescription}
//         setSearchProps={setSearchProps}
//         setShow={setShowModal}
//         onAddSku={handleAddSku}
//         setCardSearch={setCardSearch}
//         cardSearch={cardSearch}
//       />
//       <div className="drag_section">
//         <DragDropContext onDragEnd={handleDragEnd}>
//           <Droppable droppableId="droppable-cards">
//             {(provided) => (
//               <div ref={provided.innerRef} {...provided.droppableProps}>
//                 {cardFields.map((card, index) => (
//                   <Draggable
//                     key={card.id}
//                     draggableId={`card-${index}`}
//                     index={index}
//                   >
//                     {(provided) => (
//                       <Card
//                         ref={provided.innerRef}
//                         {...provided.draggableProps}
//                         {...provided.dragHandleProps}
//                         className="mb-3"
//                       >
//                         <Card.Body>
//                           <div className="grag_flex_row">
//                             <Col className="drag_icon_set">
//                               <div
//                                 className="drag_icon_group"
//                                 {...provided.dragHandleProps}
//                               >
//                                 {cardFields.length > 1 && (
//                                   <IconCopyMinus
//                                     onClick={() => handleRemoveCard(index)}
//                                   />
//                                 )}
//                                 <IconGridDots style={{ cursor: "move" }} />
//                               </div>
//                             </Col>
//                             <Col className="mob_50">
//                               <Form.Group>
//                                 <Form.Label className="">
//                                   VENDOR'S PARTNER
//                                 </Form.Label>
//                                 <InputGroup>
//                                   <Form.Control
//                                     {...register(
//                                       `cards[${index}].vendorPartner`
//                                     )}
//                                     defaultValue={card.vendorPartner}
//                                     placeholder="Enter Name"
//                                     // value={cardSearch[activeCardIndex]?.vendor || ""}
//                                     onChange={(e) =>
//                                       handleSearchChange(
//                                         activeCardIndex,
//                                         "vendor",
//                                         e.target.value
//                                       )
//                                     }
//                                     onFocus={() => handleInputFocus(index)}
//                                   />
//                                 </InputGroup>
//                                 {errors?.cards?.[index]?.vendorPartner && (
//                                   <span className="text-danger">
//                                     {/* {errors.cards[index].vendorPartner.message} */}
//                                   </span>
//                                 )}
//                               </Form.Group>
//                             </Col>
//                             {showSkuId && (
//                               <Col className="mid_drag_column mob_50">
//                                 <Form.Group>
//                                   <Form.Label className="">
//                                     UNIQUE SKU ID
//                                   </Form.Label>
//                                   <InputGroup>
//                                     <Form.Control
//                                       {...register(
//                                         `cards[${index}].skuIdUnique`
//                                       )}
//                                       // value={watch(`cards[${index}].skuId`)}
//                                       placeholder="SKU ID"
//                                       defaultValue={card.skuIdUnique}
//                                     />
//                                   </InputGroup>
//                                 </Form.Group>
//                               </Col>
//                             )}
//                             <Col className="mid_drag_column mob_50">
//                               <Form.Group>
//                                 <Form.Label className="">SKU ID</Form.Label>
//                                 <InputGroup>
//                                   <Form.Control
//                                     {...register(`cards[${index}].skuId`)}
//                                     // value={watch(`cards[${index}].skuId`)}
//                                     placeholder="SKU ID"
//                                     defaultValue={card.skuId}
//                                     onChange={(e) =>
//                                       handleSearchChange(
//                                         activeCardIndex,
//                                         "sku",
//                                         e.target.value
//                                       )
//                                     }
//                                     onFocus={() => handleInputFocus(index)}
//                                   />
//                                 </InputGroup>
//                                 {errors?.cards?.[index]?.skuId && (
//                                   <span className="text-danger">
//                                     {/* {errors.cards[index].skuId.message} */}
//                                   </span>
//                                 )}
//                               </Form.Group>
//                             </Col>
//                             <Col className="mob_100">
//                               <Form.Group>
//                                 <Form.Label className="">
//                                   SKU DESCRIPTION
//                                 </Form.Label>
//                                 <InputGroup>
//                                   <Form.Control
//                                     as="textarea"
//                                     rows={1} // Adjust the number of visible text lines
//                                     {...register(
//                                       `cards[${index}].skuDescription`
//                                     )}
//                                     defaultValue={card.skuDescription}
//                                     placeholder="Description"
//                                     ref={(el) => {
//                                       textAreaRefs.current[index] = el;
//                                     }}
//                                     style={{
//                                       resize: "none",
//                                       overflow: "hidden",
//                                     }}
//                                     onChange={(e) => {
//                                       handleSearchChange(
//                                         index,
//                                         "description",
//                                         e.target.value,
//                                         setValue(
//                                           `cards[${index}].skuDescription`,
//                                           e.target.value
//                                         )
//                                       );
//                                       adjustTextAreaHeight(index); // Resize on input change
//                                     }}
//                                     onFocus={() => handleInputFocus(index)}
//                                   />
//                                 </InputGroup>
//                                 {errors?.cards?.[index]?.skuDescription && (
//                                   <span className="text-danger">
//                                     {/* {errors.cards[index].skuDescription.message} */}
//                                   </span>
//                                 )}
//                               </Form.Group>
//                             </Col>

//                             <Col className="small_drag_column mob_50">
//                               <Form.Group>
//                                 <Form.Label className="">QTY</Form.Label>
//                                 <InputGroup>
//                                   <Form.Control
//                                     type="text"
//                                     onKeyDown={handleKeyDown}
//                                     {...register(`cards[${index}].qty`, {
//                                       required: "Quantity is required",
//                                       pattern: {
//                                         value: /^[0-9]+$/,
//                                         message: "Quantity must be a number",
//                                       },
//                                     })}
//                                     defaultValue={card.qty}
//                                     placeholder="0"
//                                   />
//                                 </InputGroup>
//                                 {errors?.cards?.[index]?.qty && (
//                                   <span className="text-danger">
//                                     {/* {errors.cards[index].qty.message} */}
//                                   </span>
//                                 )}
//                               </Form.Group>
//                             </Col>

//                             <Col className="small_drag_column mob_50">
//                               <Form.Group>
//                                 <Form.Label>UM</Form.Label>
//                                 <InputGroup>
//                                   <Form.Control
//                                     {...register(`cards[${index}].um`)}
//                                     defaultValue={card.um}
//                                     placeholder="EA"
//                                   />
//                                 </InputGroup>
//                                 {errors?.cards?.[index]?.um && (
//                                   <span className="text-danger">
//                                     {/* {errors.cards[index].qty.message} */}
//                                   </span>
//                                 )}
//                               </Form.Group>
//                             </Col>

//                             <Col className="mob_50">
//                               <Form.Group className="lock_group">
//                                 <Form.Label className="">Cost</Form.Label>
//                                 <InputGroup>
//                                   <InputGroup.Text>
//                                     <IconCurrencyDollar stroke={2} />
//                                   </InputGroup.Text>

//                                   <Form.Control
//                                     type="text"
//                                     onKeyDown={handleKeyDown}
//                                     {...register(`cards[${index}].cost`, {
//                                       required: "Cost is required",
//                                       pattern: {
//                                         value: /^[0-9]+(\.[0-9]{1,2})?$/,
//                                         message: "Enter a valid cost",
//                                       },
//                                     })}
//                                     defaultValue={card.cost}
//                                     placeholder="Enter Cost"
//                                     disabled={watch(`cards[${index}].CostLock`)}
//                                   />
//                                 </InputGroup>
//                                 {errors?.cards?.[index]?.cost && (
//                                   <span className="text-danger">
//                                     {/* {errors.cards[index].cost.message} */}
//                                   </span>
//                                 )}
//                                 <span className="lock_unlock">
//                                   <Form.Check
//                                     type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
//                                     id={`lock-toggle-${index}`}
//                                     label={
//                                       <>
//                                         {watch(`cards[${index}].CostLock`) ? (
//                                           <IconLock stroke={1} />
//                                         ) : (
//                                           <IconLockOpen2 stroke={1} />
//                                         )}
//                                       </>
//                                     }
//                                     {...register(`cards[${index}].CostLock`)}
//                                     checked={watch(`cards[${index}].CostLock`)}
//                                     onChange={() =>
//                                       handleLockChange("CostLock", index)
//                                     }
//                                   />
//                                 </span>
//                               </Form.Group>
//                             </Col>

//                             <Col className="small_drag_column mob_50">
//                               <Form.Group className="lock_group">
//                                 <Form.Label className="">Margin</Form.Label>
//                                 <InputGroup>
//                                   <InputGroup.Text>
//                                     <IconPercentage stroke={2} />
//                                   </InputGroup.Text>

//                                   <Form.Control
//                                     onKeyDown={handleKeyDown}
//                                     type="text"
//                                     {...register(`cards[${index}].margin`, {
//                                       required: "Margin is required",
//                                     })}
//                                     defaultValue={card.margin}
//                                     placeholder="0.00"
//                                     disabled={watch(
//                                       `cards[${index}].marginLock`
//                                     )}
//                                   />
//                                 </InputGroup>
//                                 {errors?.cards?.[index]?.margin && (
//                                   <span className="text-danger">
//                                     {/* {errors.cards[index].margin.message} */}
//                                   </span>
//                                 )}
//                                 <span className="lock_unlock">
//                                   <Form.Check
//                                     type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
//                                     id={`margin-lock-toggle-${index}`}
//                                     label={
//                                       <>
//                                         {watch(`cards[${index}].marginLock`) ? (
//                                           <IconLock stroke={1} />
//                                         ) : (
//                                           <IconLockOpen2 stroke={1} />
//                                         )}
//                                       </>
//                                     }
//                                     {...register(`cards[${index}].marginLock`)}
//                                     checked={watch(
//                                       `cards[${index}].marginLock`
//                                     )}
//                                     onChange={() =>
//                                       handleLockChange("marginLock", index)
//                                     }
//                                   />
//                                 </span>
//                               </Form.Group>
//                             </Col>

//                             <Col className="mob_50">
//                               <Form.Group className="lock_group">
//                                 <Form.Label>Customer Price</Form.Label>
//                                 <InputGroup>
//                                   <InputGroup.Text>
//                                     <IconCurrencyDollar stroke={2} />
//                                   </InputGroup.Text>
//                                   <Form.Control
//                                     type="text"
//                                     onKeyDown={handleKeyDown}
//                                     {...register(
//                                       `cards[${index}].customerCost`,
//                                       {
//                                         required: "Customer's cost is required",
//                                         pattern: {
//                                           value: /^[0-9]+(\.[0-9]{1,2})?$/,
//                                           message:
//                                             "Enter a valid customer cost",
//                                         },
//                                       }
//                                     )}
//                                     defaultValue={card.customerCost}
//                                     placeholder="Customer's Cost"
//                                     disabled={watch(
//                                       `cards[${index}].customerCostLock`
//                                     )}
//                                     checked={watch(
//                                       `cards[${index}].customerCostLock`
//                                     )}
//                                   />
//                                 </InputGroup>
//                                 {errors?.cards?.[index]?.customerCost && (
//                                   <span className="text-danger">
//                                     {/* {errors.cards[index].customerCost.message} */}
//                                   </span>
//                                 )}
//                                 <span className="lock_unlock">
//                                   <Form.Check
//                                     type="switch"
//                                     id={`customer-cost-lock-toggle-${index}`}
//                                     label={
//                                       <>
//                                         {watch(
//                                           `cards[${index}].customerCostLock`
//                                         ) ? (
//                                           <IconLock stroke={1} />
//                                         ) : (
//                                           <IconLockOpen2 stroke={1} />
//                                         )}
//                                       </>
//                                     }
//                                     {...register(
//                                       `cards[${index}].customerCostLock`
//                                     )}
//                                     checked={watch(
//                                       `cards[${index}].customerCostLock`
//                                     )}
//                                     onChange={() =>
//                                       handleLockChange(
//                                         "customerCostLock",
//                                         index
//                                       )
//                                     }
//                                   />
//                                 </span>
//                               </Form.Group>
//                             </Col>

//                             <Col className="mob_50">
//                               <Form.Group>
//                                 <Form.Label>Total SKU Price</Form.Label>
//                                 <InputGroup>
//                                   <InputGroup.Text>
//                                     <IconCurrencyDollar stroke={2} />
//                                   </InputGroup.Text>
//                                   <Form.Control
//                                     readOnly
//                                     type="text"
//                                     onKeyDown={handleKeyDown}
//                                     {...register(
//                                       `cards[${index}].totalSkuCost`,
//                                       {
//                                         required: "Total SKU cost is required",
//                                         pattern: {
//                                           value: /^[0-9]+(\.[0-9]{1,2})?$/,
//                                           message:
//                                             "Enter a valid total SKU cost",
//                                         },
//                                       }
//                                     )}
//                                     defaultValue={card.totalSkuCost}
//                                     placeholder="Total SKU Cost"
//                                   />
//                                 </InputGroup>
//                                 {errors?.cards?.[index]?.totalSkuCost && (
//                                   <span className="text-danger">
//                                     {errors.cards[index].totalSkuCost.message}
//                                   </span>
//                                 )}
//                               </Form.Group>
//                             </Col>
//                           </div>
//                           {cardSearch[index]?.showSuggestions &&
//                             (cardSearch[index]?.vendor ||
//                               cardSearch[index]?.sku ||
//                               cardSearch[index]?.description) &&
//                             dataSuggetion?.data?.length > 0 && (
//                               <div className="suggestions_box">
//                                 <div className="table-responsive">
//                                   <Table>
//                                     <tbody>
//                                       {dataSuggetion.data.map(
//                                         (product, idx) => (
//                                           <tr
//                                             key={idx}
//                                             onClick={() =>
//                                               handleProductSelect(
//                                                 product,
//                                                 index
//                                               )
//                                             }
//                                           >
//                                             <td>
//                                               {product?.Vendor?.display_name}
//                                             </td>
//                                             <td>{product?.sku_id}</td>
//                                             <td>
//                                               {" "}
//                                               {trimText(
//                                                 product?.description,
//                                                 100
//                                               )}
//                                             </td>
//                                             <td>{product?.uoi}</td>
//                                             <td>${product?.aspetto_price}</td>
//                                             <td>{product?.margin_percent}%</td>
//                                           </tr>
//                                         )
//                                       )}
//                                     </tbody>
//                                   </Table>
//                                 </div>
//                                 <div className="text-center">
//                                   <Button
//                                     variant="link"
//                                     className="see-all-btn"
//                                     onClick={() =>
//                                       handleOpenModal(index, "sku")
//                                     }
//                                   >
//                                     See All SKUs <IconArrowNarrowRight />
//                                   </Button>
//                                 </div>
//                               </div>
//                             )}
//                         </Card.Body>
//                       </Card>
//                     )}
//                   </Draggable>
//                 ))}
//                 {provided.placeholder}
//               </div>
//             )}
//           </Droppable>

//           <div className="add_remove_sku mb-3">
//             <p className="text-center mb-2">Product Items (SKUs)</p>
//             <div className="btn_group_sku">
//               <Button
//                 variant=""
//                 className="add_sku_button"
//                 onClick={handleAddCard}
//               >
//                 <IconPlus /> BLANK PRODUCT
//               </Button>
//               <Button
//                 variant=""
//                 className="add_sku_button"
//                 onClick={() => handleOpenModal(null, "skuAll")}
//               >
//                 <IconSearch /> PRODUCTS LIBRARY
//               </Button>
//               {/* <Button
//                                 variant=""
//                                 className="add_sku_button"
//                                 onClick={() => handleOpenModal(null, "contract")}
//                             >
//                                 <IconSearch /> BROWSE BY CONTRACT VEHICLE
//                             </Button> */}
//             </div>
//           </div>
//         </DragDropContext>
//       </div>
//     </>
//   );
// }

// export default KitProducts;

import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Card,
  Button,
  Table,
} from "react-bootstrap";
import {
  IconCopyMinus,
  IconGridDots,
  IconInvoice,
  IconSearch,
  IconCoin,
  IconPercentage,
  IconCurrencyDollar,
  IconArrowNarrowRight,
  IconPlus,
  IconTrash,
  IconLock,
  IconLockOpen2,
} from "@tabler/icons-react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useSelector } from "react-redux";
import { useFormContext, useFieldArray } from "react-hook-form";
import {
  API_ENDPOINTS,
  handleKeyDown,
  roundToMoney,
  trimText,
  truncateFormat,
} from "../../constant/_constant";
import SkuSearchPopUp from "./SkuSearchPopUp";

import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { toast } from "react-toastify";

function KitProducts() {
  const {
    getValues,
    register,
    watch,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const contractName = useSelector((state) => state.contract.contractName);
  const firstProductTypeRef = useRef(null);
  const textareaRef = useRef(null);

  const [dataSuggetion, setDataSuggetion] = useState([]);
  const [showSkuId, setShowSkuId] = useState(false);
  const [height, setHeight] = useState();
  const [shippingHide, setShippingHide] = useState(false);
  const [totalCostBeforeMargin, setTotalCostBeforeMargin] = useState("0.00");
  const [totalCostAfterMargin, setTotalCostAfterMargin] = useState("0.00");
  const [showModal, setShowModal] = useState(false);

  const [searchProps, setSearchProps] = useState({
    searchSku: "",
    searchDescription: "",
    searchVendor: "",
    indexIs: "",
    ContractName: "",
  });

  const handleOpenModal = (index, type) => {
    if (index === null && type === "skuAll") {
      const currentCards = getValues("cards");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuIdUnique && !card.cost && !card.skuDescription
      );

      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          indexIs: undefined,
        });
      }
    } else if (index === null && type === "contract") {
      const currentCards = getValues("cards");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuIdUnique && !card.cost && !card.skuDescription
      );

      // setSearchProps({
      //   searchSku: "",
      //   searchDescription: "",
      //   searchVendor: "",
      //   ContractName: contractName,
      // });

      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: undefined,
        });
      }
    } else {
      const { vendor, sku, description } = cardSearch[index];
      setSearchProps({
        searchSku: sku,
        searchDescription: description,
        searchVendor: vendor,
        indexIs: index,
      });
    }
    setShowModal(true);
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const {
    fields: cardFields,
    append: appendCard,
    remove: removeCard,
  } = useFieldArray({
    control,
    name: "cards",
  });

  const {
    fields: otherCostFields,
    append: appendOtherCost,
    remove: removeOtherCost,
  } = useFieldArray({
    control,
    name: "otherCost",
  });

  const handleAddOtherCost = () => {
    appendOtherCost({
      Name: "",
      Amount: "",
    });
  };

  const generateUniqueId10 = () => {
    const array = new Uint8Array(8);
    crypto.getRandomValues(array);

    const id = btoa(String.fromCharCode(...array))
      .replace(/[^a-zA-Z0-9]/g, "")
      .slice(0, 10);

    console.log("Generated ID:", id);
    return id;
  };

  const handleAddCard = () => {
    const rowId = generateUniqueId10();
    appendCard({
      vendorPartner: "",
      skuIdUnique: "",
      skuId: "",
      skuDescription: "",
      productName: "",
      rowId: rowId,
      qty: 1,
      um: "EA",
      cost: "",
      margin: 0,
      customerCost: "",
      totalSkuCost: "",
      productType: "",
    });
    // calculateCosts();
  };

  const handleAddSku = (product) => {
    const firstCardType = getValues("productType");
    const incomingType = product?.type;
    if (firstCardType && incomingType !== firstCardType?.incomingType) {
      toast.error(
        `All kit products must be of the same type. First item is "${firstCardType?.incomingType}".`
      );
      return;
    }

    // const costValue =
    //   Number(product?.aspetto_price) === 0
    //     ? product?.customer_price
    //     : product?.aspetto_price;
    const rowId = generateUniqueId10();

    const costValueCustomer =
      Number(product?.customer_price) === 0
        ? product?.aspetto_price
        : product?.customer_price;

    appendCard({
      vendorPartner: product?.Vendor?.display_name,
      skuId: product?.sku_display_name,
      skuIdUnique: product?.sku_id,
      skuDescription: product?.description,
      productName: product?.name,
      qty: 1,
      um: "EA",
      rowId: rowId,
      // margin: product?.margin_percent,
      cost: product?.aspetto_price,
      customerCost: costValueCustomer,
      // totalSkuCost: product?.aspetto_price,
    });
    calculateCosts();
  };

  const handleLockUnLock = (e, index, type) => {
    e.stopPropagation();
  };

  useEffect(() => {
    const cards = getValues("cards") || [];

    const hasFilledCard = cards.some(
      (card) => card.skuIdUnique && card.skuIdUnique.trim() !== ""
    );

    if (!hasFilledCard) {
      setValue("productType", null);
    }
  }, [watch("cards"), setValue]);

  useEffect(() => {
    const existingCards = getValues("cards");
    const rowId = generateUniqueId10();
    if (!existingCards || existingCards.length === 0) {
      appendCard({
        vendorPartner: "",
        skuIdUnique: "",
        skuId: "",
        skuDescription: "",
        rowId: rowId,
        productName: "",
        qty: 1,
        um: "EA",
        cost: "",
        margin: 0,
        customerCost: "",
        totalSkuCost: "",
      });
    }
  }, [appendCard, getValues]);

  const handleRemoveCard = (index) => {
    const currentCards = getValues("cards");
    if (cardFields.length > 1) {
      removeCard(index);
      setTimeout(() => {
        const updatedCards = getValues("cards");
        calculateCosts(updatedCards);
      }, 0);
    }
  };

  const handleRemoveOthercost = (index) => {
    const currentOthercost = getValues("otherCost");
    if (otherCostFields.length > 0) {
      removeOtherCost(index);
      setTimeout(() => {
        const updatedOthercost = getValues("otherCost");
        calculateCosts(updatedOthercost);
      }, 0);
    }
  };

  const handleDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination || destination.index === source.index) return;
    const currentValues = getValues("cards");
    const reorderedCards = [...currentValues];
    const [removed] = reorderedCards.splice(source.index, 1);
    reorderedCards.splice(destination.index, 0, removed);
    setValue("cards", reorderedCards);
  };

  // const calculateCosts = (name) => {
  //   let currentfield = "";
  //   let currentindex = null;
  //   if (typeof name === "string") {
  //     const pathParts = name.match(/cards\[(\d+)\]\.(\w+)/);
  //           currentindex = pathParts ? parseInt(pathParts[1]) : null;
  //     currentfield = pathParts ? pathParts[2] : null;
  //   }

  //   let totalBeforeMargin = 0;
  //   let totalAfterMargin = 0;

  //   const cards = getValues("cards") || [];
  //   const otherCost = getValues("otherCost") || [];

  //   const shippingCost = parseFloat(getValues("shippingCost")) || 0;
  //   const tax = parseFloat(getValues("tax")) || 0;

  //   cards?.forEach((card, index) => {

  //     if (currentfield !== "" && currentindex !== null && currentindex !== index) {
  //       // This card didn't change - just add its totals
  //       totalBeforeMargin += parseFloat(card.cost || 0) * parseFloat(card.qty || 0);
  //       totalAfterMargin += parseFloat(card.customerCost || 0) * parseFloat(card.qty || 0);
  //       return; // Skip recalculation for this card
  //     }

  //     if (currentfield != "" && currentindex === index) {
  //       const customerCostLock = card.customerCostLock;
  //       const costLock = card.CostLock;
  //       const marginLock = card.marginLock;
  //       const qty = parseFloat(card.qty) || 0;
  //       let cost = parseFloat(card.cost) || 0;
  //       let margin = parseFloat(card.margin) || 0;
  //       let customerCost = parseFloat(card.customerCost) || 0;
  //       let totalSkuCost = 0;
  //       const lockFields = ["customerCostLock", "CostLock", "marginLock"];

  //       if (lockFields.includes(currentfield)) {
  //         return;
  //       }

  //       if (
  //         customerCostLock == false &&
  //         costLock == false &&
  //         marginLock == false
  //       ) {
  //         if (currentfield == "customerCost") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           if (cost == 0) {
  //             console.log("margin is 0 because cost is 0");
  //             margin = 0;
  //             setValue(
  //               `cards[${cards.indexOf(card)}].cost`,
  //               truncateFormat(totalSkuCost, 2)
  //             );
  //           } else {
  //             margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           }
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (customerCostLock == true) {
  //         if (currentfield == "cost") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else if (currentfield == "margin") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // margin
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (marginLock == true) {
  //         if (currentfield == "cost") {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else if (currentfield == "customerCost") {
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // customer cost
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (costLock == true) {
  //         if (currentfield == "margin") {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // customer cost change , need to calculate margin
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       }
  //       totalBeforeMargin += cost * qty;
  //       totalAfterMargin += parseFloat(totalSkuCost);
  //     } else {
  //       totalBeforeMargin += parseFloat(card.cost * card.qty);
  //       totalAfterMargin += parseFloat(card.customerCost * card.qty);
  //     }
  //   });

  //   // Calculate costs for each other cost
  //   otherCost?.forEach((costItem) => {
  //     const amount = parseFloat(costItem.Amount) || 0;
  //     if (amount > 0) {
  //       totalBeforeMargin += parseFloat(amount);
  //       totalAfterMargin += parseFloat(amount);
  //     }
  //   });

  //   if (shippingCost > 0) {
  //     totalBeforeMargin += parseFloat(shippingCost);
  //     totalAfterMargin += parseFloat(shippingCost);
  //   }

  //   // Add tax if enabled
  //   if (tax > 0) {
  //     // console.log('tax', tax);
  //     totalBeforeMargin += parseFloat(tax);
  //     totalAfterMargin += parseFloat(tax);
  //   }

  //   // Set the final values
  //   setTotalCostBeforeMargin(truncateFormat(totalBeforeMargin, 2));
  //   setTotalCostAfterMargin(truncateFormat(totalAfterMargin, 2));

  //   // Update form state
  //   setValue("totalCostBeforeMargin", truncateFormat(totalBeforeMargin, 2));
  //   setValue("totalCostAfterMargin", truncateFormat(totalAfterMargin, 2));
  // };

  const calculateCosts = (name) => {
    let currentfield = "";
    let currentindex = null;
    if (typeof name === "string") {
      const pathParts = name.match(/cards\[(\d+)\]\.(\w+)/);
      currentindex = pathParts ? parseInt(pathParts[1]) : null;
      currentfield = pathParts ? pathParts[2] : null;
    }

    let totalBeforeMargin = 0;
    let totalAfterMargin = 0;

    const cards = getValues("cards") || [];
    const otherCost = getValues("otherCost") || [];

    const shippingCost = parseFloat(getValues("shippingCost")) || 0;
    const tax = parseFloat(getValues("tax")) || 0;

    cards?.forEach((card, index) => {
      if (currentfield !== "" && currentindex !== null && currentindex !== index) {
        // This card didn't change - just add its totals
        totalBeforeMargin += parseFloat(card.cost || 0) * parseFloat(card.qty || 0);
        totalAfterMargin += parseFloat(card.customerCost || 0) * parseFloat(card.qty || 0);
        return; // Skip recalculation for this card
      }

      if (currentfield != "" && currentindex === index) {
        const customerCostLock = card.customerCostLock;
        const costLock = card.CostLock;
        const marginLock = card.marginLock;
        const qty = parseFloat(card.qty) || 0;
        let cost = parseFloat(card.cost) || 0;
        let margin = parseFloat(card.margin) || 0;
        let customerCost = parseFloat(card.customerCost) || 0;
        let totalSkuCost = 0;
        const lockFields = ["customerCostLock", "CostLock", "marginLock"];

        if (lockFields.includes(currentfield)) {
          return;
        }

        if (
          customerCostLock == false &&
          costLock == false &&
          marginLock == false
        ) {
          if (currentfield == "customerCost") {
            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            if (cost == 0) {
              console.log("margin is 0 because cost is 0");
              margin = 0;
              setValue(
                `cards[${cards.indexOf(card)}].cost`,
                roundToMoney(totalSkuCost)
              );
            } else {
              margin = parseFloat(((roundedCustomerCost - cost) / roundedCustomerCost) * 100);
            }

            // ADDED: Store rounded customerCost
            // setValue(
            //   `cards[${cards.indexOf(card)}].customerCost`,
            //   roundedCustomerCost
            // );
            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin)
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          } else {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          }
        } else if (customerCostLock == true) {
          if (currentfield == "cost") {
            margin = parseFloat(((customerCost - cost) / customerCost) * 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin)
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          } else if (currentfield == "margin") {
            const costCust = customerCost * (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(costCust)
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          } else {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(cost)
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          }
        } else if (marginLock == true) {
          if (currentfield == "cost") {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          } else if (currentfield == "customerCost") {
            const costCust = customerCost * (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(costCust)
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          } else {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(cost)
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          }
        } else if (costLock == true) {
          if (currentfield == "margin") {
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          } else {
            margin = parseFloat(((customerCost - cost) / customerCost) * 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin)
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost)
            );
          }
        }

        // FIXED: Use rounded values for accumulation
        totalBeforeMargin += roundToMoney(cost * qty);
        totalAfterMargin += roundToMoney(totalSkuCost);
      } else {
        totalBeforeMargin += parseFloat(card.cost * card.qty);
        totalAfterMargin += parseFloat(card.customerCost * card.qty);
      }
    });

    // Calculate costs for each other cost
    otherCost?.forEach((costItem) => {
      const amount = parseFloat(costItem.Amount) || 0;
      if (amount > 0) {
        totalBeforeMargin += parseFloat(amount);
        totalAfterMargin += parseFloat(amount);
      }
    });

    if (shippingCost > 0) {
      totalBeforeMargin += parseFloat(shippingCost);
      totalAfterMargin += parseFloat(shippingCost);
    }

    // Add tax if enabled
    if (tax > 0) {
      totalBeforeMargin += parseFloat(tax);
      totalAfterMargin += parseFloat(tax);
    }

    // Set the final values - FIXED
    setTotalCostBeforeMargin(roundToMoney(totalBeforeMargin));
    setTotalCostAfterMargin(roundToMoney(totalAfterMargin));

    // Update form state - FIXED
    setValue("totalCostBeforeMargin", roundToMoney(totalBeforeMargin));
    setValue("totalCostAfterMargin", roundToMoney(totalAfterMargin));
  };

  const isCalculating = useRef(false);

  const shipping_terms = watch("shipping_terms");

  useEffect(() => {
    if (shipping_terms === "FOB Destination") {
      setShippingHide(true);
    }
  }, [watch("shipping_terms")]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      //console.log('set name',name);
      const match = name?.match(
        /cards\[(\d+)\]\.(qty|cost|margin|customerCost)/
      );
      const otherCostMatch = name?.match(/otherCost\[(\d+)\]\.Amount/);
      if (match || otherCostMatch) {
        if (!isCalculating.current) {
          isCalculating.current = true;
          calculateCosts(name);
          isCalculating.current = false;
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (!isCalculating.current) {
      isCalculating.current = true;
      calculateCosts();
      isCalculating.current = false;
    }
  }, [watch("shippingCost"), watch("tax"), watch("cards"), watch("otherCost")]);

  const [activeCardIndex, setActiveCardIndex] = useState(null);
  const [cardSearch, setCardSearch] = useState(
    cardFields.map(() => ({
      vendor: "",
      description: "",
      sku: "",
      showSuggestions: true,
    }))
  );

  const handleInputFocus = (index) => {
    setActiveCardIndex(index);
    const updatedCardSearch = cardSearch.map((card, idx) => {
      if (idx !== index) {
        return { ...card, showSuggestions: false };
      }
      return card;
    });
    setCardSearch(updatedCardSearch);
  };

  const handleSearchChange = (index, field, value) => {
    const updatedCardSearch = [...cardSearch];
    if (field === "sku") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        sku: value,
        vendor: "",
        description: "",
        showSuggestions: true,
      };
    } else if (field === "vendor") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        vendor: value,
        sku: "",
        description: "",
        showSuggestions: true,
      };
    } else if (field === "description") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        description: value,
        sku: "",
        vendor: "",
        showSuggestions: true,
      };
    }
    setCardSearch(updatedCardSearch);
  };

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION
  );

  const onSuccessData = (data) => {
    // console.log("data sugesstion",data)
    setDataSuggetion(data);
  };

  useEffect(() => {
    if (
      activeCardIndex === null ||
      !cardSearch[activeCardIndex]?.showSuggestions
    ) {
      return;
    }

    const { vendor, sku, description } = cardSearch[activeCardIndex];

    if (!vendor && !sku && !description) {
      return;
    }

    const debounceTimer = setTimeout(() => {
      fetchProductSearch(
        {
          page,
          limit,
          type: "kit-products",
          module_type: "RFQ",
          vendor: vendor?.length > 0 ? vendor : undefined,
          sku: sku?.length > 0 ? sku : undefined,
          description: description?.length > 0 ? description : undefined,
        },
        onSuccessData
      );
    }, 500);
    return () => clearTimeout(debounceTimer);
  }, [cardSearch, page, limit, activeCardIndex]);

  const textAreaRefs = useRef([]);

  const adjustTextAreaHeight = (index) => {
    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.style.height = "auto";
      textArea.style.height = `${textArea.scrollHeight}px`;
    }
  };

  // console.log("productType", getValues("productType"));

  const handleProductSelect = (product, index) => {
    // const costValue =
    //   Number(product?.aspetto_price) === 0
    //     ? product?.customer_price
    //     : product?.aspetto_price;

    const costValueCustomer =
      Number(product?.customer_price) === 0
        ? product?.aspetto_price
        : product?.customer_price;

    const incomingType = product?.type;
    const isFirstCard = index === 0;
    if (isFirstCard) {
      setValue("productType", { incomingType });
    } else {
      const firstCardType = getValues("productType");
      console.log("firstCardType", firstCardType);
      console.log("incomingType", incomingType);
      if (firstCardType && incomingType !== firstCardType?.incomingType) {
        toast.error(
          `All kit products must be of the same type. First item is "${firstCardType?.incomingType}".`
        );
        return;
      }
    }
    setValue(`cards[${index}].vendorPartner`, product?.Vendor?.display_name, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].skuIdUnique`, product?.sku_id, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].skuId`, product?.sku_display_name, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].productName`, product?.name, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].skuDescription`, product?.description, {
      shouldValidate: true,
    }); // Description update
    setValue(`cards[${index}].um`, product?.uoi ?? "EA", {
      shouldValidate: true,
    });
    setValue(`cards[${index}].cost`, product?.aspetto_price, {
      shouldValidate: true,
    });
    setValue(`cards[${index}].customerCost`, costValueCustomer, {
      shouldValidate: true,
    });
    // setValue(`cards[${index}].margin`, product?.margin_percent, {
    //   shouldValidate: true,
    // });

    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.value = product?.description;
      adjustTextAreaHeight(index);
    }

    const updatedCardSearch = [...cardSearch];
    updatedCardSearch[index] = {
      ...updatedCardSearch[index],
      showSuggestions: false,
    };
    setCardSearch(updatedCardSearch);
  };

  useEffect(() => {
    cardFields.forEach((_, index) => {
      adjustTextAreaHeight(index);
    });
  }, [cardFields]);

  const cards = watch("cards");

  const handleLockChange = (field, index) => {
    const currentState = watch(`cards[${index}]`);
    if (currentState[field]) {
      setValue(`cards[${index}].${field}`, false);
    } else {
      // Otherwise, lock it and unlock all others
      setValue(`cards[${index}].CostLock`, field === "CostLock");
      setValue(`cards[${index}].marginLock`, field === "marginLock");
      setValue(
        `cards[${index}].customerCostLock`,
        field === "customerCostLock"
      );
    }
  };

  const updateTextAreaWithDescription = (index, description) => {
    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.value = description;
      adjustTextAreaHeight(index);
    }
  };

  return (
    <>
      <SkuSearchPopUp
        calculateCosts={calculateCosts}
        show={showModal}
        searchProps={searchProps}
        updateTextArea={updateTextAreaWithDescription}
        setSearchProps={setSearchProps}
        setShow={setShowModal}
        onAddSku={handleAddSku}
        setCardSearch={setCardSearch}
        cardSearch={cardSearch}
      />
      <div className="drag_section">
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable-cards">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {cardFields.map((card, index) => (
                  <Draggable
                    key={card.id}
                    draggableId={`card-${index}`}
                    index={index}
                  >
                    {(provided) => (
                      <Card
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="mb-3"
                      >
                        <Card.Body>
                          <div className="grag_flex_row">
                            <Col className="drag_icon_set">
                              <div
                                className="drag_icon_group"
                                {...provided.dragHandleProps}
                              >
                                {cardFields.length > 1 && (
                                  <IconCopyMinus
                                    onClick={() => handleRemoveCard(index)}
                                  />
                                )}
                                <IconGridDots style={{ cursor: "move" }} />
                              </div>
                            </Col>
                            <Col className="mob_50">
                              <Form.Group>
                                <Form.Label className="">
                                  VENDOR'S PARTNER
                                </Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    {...register(
                                      `cards[${index}].vendorPartner`
                                    )}
                                    defaultValue={card.vendorPartner}
                                    placeholder="Enter Name"
                                    // value={cardSearch[activeCardIndex]?.vendor || ""}
                                    onChange={(e) =>
                                      handleSearchChange(
                                        activeCardIndex,
                                        "vendor",
                                        e.target.value
                                      )
                                    }
                                    onFocus={() => handleInputFocus(index)}
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.vendorPartner && (
                                  <span className="text-danger">
                                    {/* {errors.cards[index].vendorPartner.message} */}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>
                            <div className="mid_drag_column mob_50">
                              <Form.Group>
                                <Form.Label className="">
                                  PRODUCT NAME
                                </Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    {...register(`cards[${index}].productName`)}
                                    placeholder="Product Name"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>
                            {showSkuId && (
                              <>
                              <Col className="mid_drag_column mob_50">
                                <Form.Group>
                                  <Form.Label className="">
                                    UNIQUE SKU ID
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      {...register(
                                        `cards[${index}].skuIdUnique`
                                      )}
                                      // value={watch(`cards[${index}].skuId`)}
                                      placeholder="SKU ID"
                                      defaultValue={card.skuIdUnique}
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Col>
                            <div className="mid_drag_column mob_50">
                              <Form.Group>
                                <Form.Label className="">ROW ID</Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    {...register(`cards[${index}].rowId`)}
                                    // value={watch(`cards[${index}].skuId`)}
                                    placeholder="SKU ID"
                                  // defaultValue={card.skuId}
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>
                            </>
                            )}
                            <Col className="mid_drag_column mob_50">
                              <Form.Group>
                                <Form.Label className="">SKU ID</Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    {...register(`cards[${index}].skuId`)}
                                    // value={watch(`cards[${index}].skuId`)}
                                    placeholder="SKU ID"
                                    defaultValue={card.skuId}
                                    onChange={(e) =>
                                      handleSearchChange(
                                        activeCardIndex,
                                        "sku",
                                        e.target.value
                                      )
                                    }
                                    onFocus={() => handleInputFocus(index)}
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.skuId && (
                                  <span className="text-danger">
                                    {/* {errors.cards[index].skuId.message} */}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>
                            <Col className="mob_100">
                              <Form.Group>
                                <Form.Label className="">
                                  SKU DESCRIPTION
                                </Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    as="textarea"
                                    rows={1} // Adjust the number of visible text lines
                                    {...register(
                                      `cards[${index}].skuDescription`
                                    )}
                                    defaultValue={card.skuDescription}
                                    placeholder="Description"
                                    ref={(el) => {
                                      textAreaRefs.current[index] = el;
                                    }}
                                    style={{
                                      resize: "none",
                                      overflow: "hidden",
                                    }}
                                    onChange={(e) => {
                                      handleSearchChange(
                                        index,
                                        "description",
                                        e.target.value,
                                        setValue(
                                          `cards[${index}].skuDescription`,
                                          e.target.value
                                        )
                                      );
                                      adjustTextAreaHeight(index); // Resize on input change
                                    }}
                                    onFocus={() => handleInputFocus(index)}
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.skuDescription && (
                                  <span className="text-danger">
                                    {/* {errors.cards[index].skuDescription.message} */}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col className="small_drag_column mob_50">
                              <Form.Group>
                                <Form.Label className="">QTY</Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    type="text"
                                    onKeyDown={handleKeyDown}
                                    {...register(`cards[${index}].qty`, {
                                      required: "Quantity is required",
                                      pattern: {
                                        value: /^[0-9]+$/,
                                        message: "Quantity must be a number",
                                      },
                                    })}
                                    defaultValue={card.qty}
                                    placeholder="0"
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.qty && (
                                  <span className="text-danger">
                                    {/* {errors.cards[index].qty.message} */}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col className="small_drag_column mob_50">
                              <Form.Group>
                                <Form.Label>UM</Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    {...register(`cards[${index}].um`)}
                                    defaultValue={card.um}
                                    placeholder="EA"
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.um && (
                                  <span className="text-danger">
                                    {/* {errors.cards[index].qty.message} */}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>

                            <Col className="mob_50">
                              <Form.Group className="lock_group">
                                <Form.Label className="">Cost</Form.Label>
                                <InputGroup>
                                  <InputGroup.Text>
                                    <IconCurrencyDollar stroke={2} />
                                  </InputGroup.Text>

                                  <Form.Control
                                    type="text"
                                    onKeyDown={handleKeyDown}
                                    {...register(`cards[${index}].cost`, {
                                      required: "Cost is required",
                                      pattern: {
                                        value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                        message: "Enter a valid cost",
                                      },
                                    })}
                                    defaultValue={card.cost}
                                    placeholder="Enter Cost"
                                    disabled={watch(`cards[${index}].CostLock`)}
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.cost && (
                                  <span className="text-danger">
                                    {/* {errors.cards[index].cost.message} */}
                                  </span>
                                )}
                                <span className="lock_unlock">
                                  <Form.Check
                                    type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                    id={`lock-toggle-${index}`}
                                    label={
                                      <>
                                        {watch(`cards[${index}].CostLock`) ? (
                                          <IconLock stroke={1} />
                                        ) : (
                                          <IconLockOpen2 stroke={1} />
                                        )}
                                      </>
                                    }
                                    {...register(`cards[${index}].CostLock`)}
                                    checked={watch(`cards[${index}].CostLock`)}
                                    onChange={() =>
                                      handleLockChange("CostLock", index)
                                    }
                                  />
                                </span>
                              </Form.Group>
                            </Col>

                            <Col className="small_drag_column mob_50">
                              <Form.Group className="lock_group">
                                <Form.Label className="">Margin</Form.Label>
                                <InputGroup>
                                  <InputGroup.Text>
                                    <IconPercentage stroke={2} />
                                  </InputGroup.Text>

                                  <Form.Control
                                    onKeyDown={handleKeyDown}
                                    type="text"
                                    {...register(`cards[${index}].margin`, {
                                      required: "Margin is required",
                                    })}
                                    defaultValue={card.margin}
                                    placeholder="0.00"
                                    disabled={watch(
                                      `cards[${index}].marginLock`
                                    )}
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.margin && (
                                  <span className="text-danger">
                                    {/* {errors.cards[index].margin.message} */}
                                  </span>
                                )}
                                <span className="lock_unlock">
                                  <Form.Check
                                    type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                    id={`margin-lock-toggle-${index}`}
                                    label={
                                      <>
                                        {watch(`cards[${index}].marginLock`) ? (
                                          <IconLock stroke={1} />
                                        ) : (
                                          <IconLockOpen2 stroke={1} />
                                        )}
                                      </>
                                    }
                                    {...register(`cards[${index}].marginLock`)}
                                    checked={watch(
                                      `cards[${index}].marginLock`
                                    )}
                                    onChange={() =>
                                      handleLockChange("marginLock", index)
                                    }
                                  />
                                </span>
                              </Form.Group>
                            </Col>

                            <Col className="mob_50">
                              <Form.Group className="lock_group">
                                <Form.Label>Customer Price</Form.Label>
                                <InputGroup>
                                  <InputGroup.Text>
                                    <IconCurrencyDollar stroke={2} />
                                  </InputGroup.Text>
                                  <Form.Control
                                    type="text"
                                    onKeyDown={handleKeyDown}
                                    {...register(
                                      `cards[${index}].customerCost`,
                                      {
                                        required: "Customer's cost is required",
                                        pattern: {
                                          value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                          message:
                                            "Enter a valid customer cost",
                                        },
                                      }
                                    )}
                                    defaultValue={card.customerCost}
                                    placeholder="Customer's Cost"
                                    disabled={watch(
                                      `cards[${index}].customerCostLock`
                                    )}
                                    checked={watch(
                                      `cards[${index}].customerCostLock`
                                    )}
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.customerCost && (
                                  <span className="text-danger">
                                    {/* {errors.cards[index].customerCost.message} */}
                                  </span>
                                )}
                                <span className="lock_unlock">
                                  <Form.Check
                                    type="switch"
                                    id={`customer-cost-lock-toggle-${index}`}
                                    label={
                                      <>
                                        {watch(
                                          `cards[${index}].customerCostLock`
                                        ) ? (
                                          <IconLock stroke={1} />
                                        ) : (
                                          <IconLockOpen2 stroke={1} />
                                        )}
                                      </>
                                    }
                                    {...register(
                                      `cards[${index}].customerCostLock`
                                    )}
                                    checked={watch(
                                      `cards[${index}].customerCostLock`
                                    )}
                                    onChange={() =>
                                      handleLockChange(
                                        "customerCostLock",
                                        index
                                      )
                                    }
                                  />
                                </span>
                              </Form.Group>
                            </Col>

                            <Col className="mob_50">
                              <Form.Group>
                                <Form.Label>Total SKU Price</Form.Label>
                                <InputGroup>
                                  <InputGroup.Text>
                                    <IconCurrencyDollar stroke={2} />
                                  </InputGroup.Text>
                                  <Form.Control
                                    readOnly
                                    type="text"
                                    onKeyDown={handleKeyDown}
                                    {...register(
                                      `cards[${index}].totalSkuCost`,
                                      {
                                        required: "Total SKU cost is required",
                                        pattern: {
                                          value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                          message:
                                            "Enter a valid total SKU cost",
                                        },
                                      }
                                    )}
                                    defaultValue={card.totalSkuCost}
                                    placeholder="Total SKU Cost"
                                  />
                                </InputGroup>
                                {errors?.cards?.[index]?.totalSkuCost && (
                                  <span className="text-danger">
                                    {errors.cards[index].totalSkuCost.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Col>
                          </div>
                          {cardSearch[index]?.showSuggestions &&
                            (cardSearch[index]?.vendor ||
                              cardSearch[index]?.sku ||
                              cardSearch[index]?.description) &&
                            dataSuggetion?.data?.length > 0 && (
                              <div className="suggestions_box">
                                <div className="table-responsive">
                                  <Table>
                                    <tbody>
                                      {dataSuggetion.data.map(
                                        (product, idx) => (
                                          <tr
                                            key={idx}
                                            onClick={() =>
                                              handleProductSelect(
                                                product,
                                                index
                                              )
                                            }
                                          >
                                            <td>
                                              {product?.Vendor?.display_name}
                                            </td>
                                            <td>{product?.sku_display_name}</td>
                                            <td>{product?.name}</td>
                                            <td>
                                              {" "}
                                              {trimText(
                                                product?.description,
                                                100
                                              )}
                                            </td>
                                            <td>{product?.uoi}</td>
                                            <td>${product?.aspetto_price}</td>
                                            <td>{product?.margin_percent}%</td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                                <div className="text-center">
                                  <Button
                                    variant="link"
                                    className="see-all-btn"
                                    onClick={() =>
                                      handleOpenModal(index, "sku")
                                    }
                                  >
                                    See All SKUs <IconArrowNarrowRight />
                                  </Button>
                                </div>
                              </div>
                            )}
                        </Card.Body>
                      </Card>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>

          <div className="add_remove_sku mb-3">
            <p className="text-center mb-2">Product Items (SKUs)</p>
            <div className="btn_group_sku">
              <Button
                variant=""
                className="add_sku_button"
                onClick={handleAddCard}
              >
                <IconPlus /> BLANK PRODUCT
              </Button>
              <Button
                variant=""
                className="add_sku_button"
                onClick={() => handleOpenModal(null, "skuAll")}
              >
                <IconSearch /> PRODUCTS LIBRARY
              </Button>
              {/* <Button
                                variant=""
                                className="add_sku_button"
                                onClick={() => handleOpenModal(null, "contract")}
                            >
                                <IconSearch /> BROWSE BY CONTRACT VEHICLE
                            </Button> */}
            </div>
          </div>
        </DragDropContext>
      </div>
    </>
  );
}

export default KitProducts;
